var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useCallback } from 'react';
import { Linking, Platform, Pressable } from 'react-native';
import { Col, Icon, Row, TextBody } from '../../atoms';
export function BreadcrumbItem({ active = false, label, href, onInnerPress, style, }) {
    // Handlers
    const handlePress = useCallback(() => {
        onInnerPress(href);
    }, [onInnerPress, href]);
    // Render
    return (_jsx(Pressable, { onPress: handlePress, style: style, children: ({ hovered }) => (_jsx(TextBody, { accessibilityRole: active ? 'none' : 'link', href: active ? undefined : href, color: active ? 'primary' : 'tertiary', em: active, style: [hovered && !active && { textDecorationLine: 'underline' }], children: label })) }));
}
export function BreadcrumbSeparator() {
    return (_jsx(Col, { mx: "1", children: _jsx(Icon, { name: "ChevronRight", size: 20, color: "tertiary" }) }));
}
export function BreadcrumbList({ items }) {
    // Handlers
    const handlePressDefault = useCallback((href) => __awaiter(this, void 0, void 0, function* () {
        // Note: on web, we render a standard anchor tag.
        if (Platform.OS !== 'web' && href && (yield Linking.canOpenURL(href))) {
            yield Linking.openURL(href);
        }
    }), []);
    // Render
    return (_jsx(Row.L, { children: items.map((item, index) => (_jsxs(Fragment, { children: [_jsx(BreadcrumbItem, Object.assign({}, item, { active: index === items.length - 1, onInnerPress: item.onPress ? item.onPress : handlePressDefault, style: {
                        cursor: !item.onPress && !item.href ? 'default' : 'pointer',
                    } })), index < items.length - 1 && _jsx(BreadcrumbSeparator, {})] }, item.label))) }));
}
